webpackJsonp([1],{

/***/ "2clu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_j_form_vue__ = __webpack_require__("AKgE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cf0ab16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_j_form_vue__ = __webpack_require__("PrrX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_j_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cf0ab16_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_j_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AKgE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_utils__ = __webpack_require__("JaHG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_perfect_scrollbar__ = __webpack_require__("Fiov");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_perfect_scrollbar_dist_css_perfect_scrollbar_css__ = __webpack_require__("ieps");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_perfect_scrollbar_dist_css_perfect_scrollbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_perfect_scrollbar_dist_css_perfect_scrollbar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__coutries_js__ = __webpack_require__("GEmN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_validator__ = __webpack_require__("kWq3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__("gyMJ");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var gMsg = {
  userError: '账号格式不正确!',
  noUser: '该账号尚未注册!',
  pwdError: '该账号密码不正确!',
  userEmpty: '请输入账号!',
  pwdEmpty: '请输入密码!',
  pwdTooShort: '密码不能短于6位',
  pwdTooLong: '密码不能长于20位',
  sysError: '系统繁忙！',
  checkCodeEmpty: '请输入验证码'
};





var pathPrefix = '/xmcaptcha-service';
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      coutries: __WEBPACK_IMPORTED_MODULE_5__coutries_js__["a" /* default */],
      showCoutries: false,
      code: '+86',
      coutry: '中国',
      user: {
        account: '',
        password: ''
      },
      jerror: {
        account: '',
        password: ''
      },
      verify: {
        account: false,
        password: false
      }
    };
  },

  computed: {
    canSubmit: function canSubmit() {
      return this.verify.account && this.verify.password;
    },
    toUrl: function toUrl() {
      return this.$store.state.toUrl;
    }
  },
  watch: {
    'user.password': function userPassword(pwd) {
      if (pwd.trim().length >= 6) this.checkPassword();
    }
  },
  methods: {
    toggleCoutries: function toggleCoutries() {
      this.showCoutries = !this.showCoutries;
    },
    selectCoutry: function selectCoutry(obj) {
      this.code = obj.code;
      this.coutry = obj.name;
      this.checkAccount();
    },
    closeList: function closeList() {
      this.showCoutries = false;
    },
    checkAccount: function checkAccount() {
      var _this = this;

      this.verify.account = false;
      var value = this.user.account.trim();
      if (!value) {
        this.jerror.account = gMsg.userEmpty;
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
          return resolve(false);
        });
      }
      if (this.code === '+86' && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_validator__["a" /* default */])(value, 'email') && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_validator__["a" /* default */])(value, 'mobile')) {
        this.jerror.account = gMsg.userError;
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
          return resolve(false);
        });
      }
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_validator__["a" /* default */])(value, 'email') && this.code && this.code != '+86') {
        value = this.code.replace(/\+/, '') + '-' + value;
      }

      return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].checkAccount({ email: value }).then(function (res) {
        var result = res.data;
        if (result.success) {
          _this.verify.account = true;
        } else {
          var msg = '';
          if (result.msg) {
            msg = result.msg;
          }
          _this.jerror.account = msg;
        }
      }).catch(function (error) {
        _this.jerror.account = gMsg.sysError;
      });
    },
    checkPassword: function checkPassword() {
      this.verify.password = false;
      var value = this.user.password.trim();
      if (!value) {
        this.jerror.password = gMsg.pwdEmpty;
        return false;
      }
      var len = value.length;
      if (len < 6) {
        this.jerror.password = gMsg.pwdTooShort;
        return false;
      }
      if (len > 20) {
        this.jerror.password = gMsg.pwdTooLong;
        return false;
      }
      this.verify.password = true;
      return true;
    },
    submit: function submit() {
      var _this2 = this;

      if (this.canSubmit) {
        //点击登录埋点
        xmLog && xmLog('pv.send', 'event', {
          currPage: "login",
          currPageId: null,
          currPageUrl: "/passport/login",
          item: "login",
          itemId: null,
          module: null,
          serviceId: "click"
        });

        this.user.account = this.user.account.trim();
        var account = this.user.account;
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_validator__["a" /* default */])(account, 'email') && this.code && this.code != '+86') {
          account = this.code.replace(/\+/, '') + '-' + account;
        }
        var user = {
          account: account,
          password: this.user.password
        };
        __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].submit(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user))).then(function (res) {
          if (res.data.success && !res.data.gotoBindMPhone && !res.data.gotoValidateMobile) {
            window.location.href = _this2.toUrl;
          } else if (res.data.ret === 211 || res.data.ret === 212) {
            _this2.$store.commit('setCheckKey', res.data.checkKey);
            _this2.$store.commit('showImageCode');
            _this2.$store.commit('setCaptchaInfo', res.data.captchaInfo);
            __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].getImageCodeInfo({ info: res.data.captchaInfo }).then(function (res) {
              var _res$data = res.data,
                  background = _res$data.background,
                  token = _res$data.token;

              _this2.$store.commit('setImageCodeURL', pathPrefix + background);
              _this2.$store.commit('setImageCodeToken', token);
            });
          } else if (res.data.gotoBindMPhone) {
            _this2.$store.commit('changeBindStatus', 'TO_BIND');
            _this2.$store.commit('setCheckKey', res.data.checkKey);
          } else if (res.data.gotoValidateMobile) {
            _this2.$store.commit('showSMSCode');
            _this2.$store.commit('setCheckKey', res.data.checkKey);
            _this2.$store.commit('setMobileReal', res.data.mobileReal);
            _this2.$store.commit('setMobileShow', res.data.mobileShow);
          } else {
            _this2.jerror.password = res.data.errorMsg;
            _this2.verify.password = false;
            _this2.user.password = '';
          }
        });
      }
    },
    findPassword: function findPassword() {
      //找回密码埋点
      xmLog && xmLog('pv.send', 'event', {
        currPage: "login",
        currPageId: null,
        currPageUrl: "/passport/login",
        item: "findPassword",
        itemId: null,
        module: null,
        serviceId: "click"
      });
      _hmt.push(['_trackEvent', 'login_password', 'click']);
    },
    rememberLogin: function rememberLogin() {
      //记住登录状态埋点
      xmLog && xmLog('pv.send', 'event', {
        currPage: "login",
        currPageId: null,
        currPageUrl: "/passport/login",
        item: "rememberLogin",
        itemId: !this.user.rememberMe,
        module: null,
        serviceId: "click"
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_3_perfect_scrollbar__["initialize"](_this3.$refs['regCodeList'], {
        minScrollbarLength: 3
      });
    });
    document.addEventListener('click', this.closeList);
    // this.$store.commit('changeBindStatus', 'TO_BIND')
  },
  destroyed: function destroyed() {
    document.removeEventListener('click', this.closeList);
  }
});

/***/ }),

/***/ "Akk1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pop_imageCode_vue__ = __webpack_require__("aYl9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_156857ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pop_imageCode_vue__ = __webpack_require__("J7G2");
function injectStyle (ssrContext) {
  __webpack_require__("b+Yh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-156857ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pop_imageCode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_156857ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pop_imageCode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DYbR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pop_smsCode_vue__ = __webpack_require__("xKRb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d56fe028_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pop_smsCode_vue__ = __webpack_require__("vxYB");
function injectStyle (ssrContext) {
  __webpack_require__("rsJ2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d56fe028"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pop_smsCode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d56fe028_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pop_smsCode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EImY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"scan-code light-way"},[_c('div',{staticClass:"scan-bord"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.status == 1),expression:"status == 1"}],staticClass:"code-pic",attrs:{"src":_vm.qrImg}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.status == 2),expression:"status == 2"}],staticClass:"scan-overdue"},[_c('p',{staticClass:"scan-txt"},[_vm._v("二维码已失效")]),_vm._v(" "),_c('a',{staticClass:"btn-com btn-lg btn-red",attrs:{"href":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.refresh($event)}}},[_vm._v("点击刷新")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.status == 3),expression:"status == 3"}],staticClass:"scan-success"},[_c('div',{staticClass:"scan-success"}),_vm._v(" "),_c('p',{staticClass:"scan-ok"},[_vm._v("扫描成功")])])]),_vm._v(" "),_c('p',{staticClass:"scan-tip"},[_vm._v("请打开喜马拉雅FM App，扫描二维码")]),_vm._v(" "),_c('p',{staticClass:"scan-tip mgt-10"},[_vm._v("免输入，快速，更安全")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Eomh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"reform"},[_c('div',{staticClass:"regiWrap"},[_c('p',{staticClass:"regTit tc"},[_vm._v("登录喜马拉雅")]),_vm._v(" "),_c('div',{staticClass:"regiBox"},[_c('a',{staticClass:"change-ways",attrs:{"href":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.toggleLoginWay($event)}}}),_vm._v(" "),_c('div',{staticClass:"regiLogo inl-b"},[_c('div',{staticClass:"whiteLogo"}),_vm._v(" "),_c('p',{staticClass:"regWayTxt"},[_vm._v("或者使用第三方登录")]),_vm._v(" "),_c('div',{staticClass:"regLoginWays"},[_c('a',{staticClass:"regLoginWx",attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.authLogin('weixin')}}},[_c('i',{staticClass:"iconfont icon-weixin"})]),_vm._v(" "),_c('a',{staticClass:"regLoginQq",attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.authLogin('tQQ')}}},[_c('i',{staticClass:"iconfont icon-ic_qq"})]),_vm._v(" "),_c('a',{staticClass:"regLoginWb",attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.authLogin('tSina')}}},[_c('i',{staticClass:"iconfont icon-ic_weibo"})])])]),_vm._v(" "),_c('div',{staticClass:"regFormBox inl-b"},[_c(_vm.curView,{tag:"component"})],1)])])]),_vm._v(" "),_c('transition-group',{attrs:{"name":"pop"}},[_c('pop-bindphone',{key:"binPhone",attrs:{"visible":_vm.bindphoneVisible}})],1),_vm._v(" "),_c('pop-smsCode',{key:"smsCode"}),_vm._v(" "),_c('pop-imageCode',{key:"imageCode"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GEmN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
    "name": "中国",
    "code": "+86",
    "engName": "China",
    "index": "0",
    "firstWord": "C",
    "shouzimu": "ZG"
}, {
    "name": "阿鲁巴",
    "code": "+297",
    "engName": "Aruba",
    "index": "1",
    "firstWord": "A",
    "shouzimu": "ALB"
}, {
    "name": "阿富汗",
    "code": "+93",
    "engName": "Afghanistan",
    "index": "2",
    "firstWord": "A",
    "shouzimu": "AFH"
}, {
    "name": "安哥拉",
    "code": "+244",
    "engName": "Angola",
    "index": "3",
    "firstWord": "A",
    "shouzimu": "AGL"
}, {
    "name": "安圭拉",
    "code": "+1264",
    "engName": "Anguilla",
    "index": "4",
    "firstWord": "A",
    "shouzimu": "AGL"
}, {
    "name": "阿尔巴尼亚",
    "code": "+355",
    "engName": "Albania",
    "index": "5",
    "firstWord": "A",
    "shouzimu": "AEBNY"
}, {
    "name": "奥兰群岛",
    "code": "+358",
    "engName": "Aland",
    "index": "6",
    "firstWord": "A",
    "shouzimu": "ALQD"
}, {
    "name": "安道尔",
    "code": "+376",
    "engName": "Andorra",
    "index": "7",
    "firstWord": "A",
    "shouzimu": "ADE"
}, {
    "name": "阿联酋",
    "code": "+971",
    "engName": "United Arab Emirates",
    "index": "8",
    "firstWord": "A",
    "shouzimu": "ALQ"
}, {
    "name": "阿根廷",
    "code": "+54",
    "engName": "Argentina",
    "index": "9",
    "firstWord": "A",
    "shouzimu": "AGT"
}, {
    "name": "亚美尼亚",
    "code": "+374",
    "engName": "Armenia",
    "index": "10",
    "firstWord": "Y",
    "shouzimu": "YMNY"
}, {
    "name": "美属萨摩亚",
    "code": "+1684",
    "engName": "American Samoa",
    "index": "11",
    "firstWord": "M",
    "shouzimu": "MSSMY"
}, {
    "name": "南极洲",
    "code": "+672",
    "engName": "Antarctica",
    "index": "12",
    "firstWord": "N",
    "shouzimu": "NJZ"
}, {
    "name": "安提瓜和巴布达",
    "code": "+1268",
    "engName": "Antigua and Barb.",
    "index": "15",
    "firstWord": "A",
    "shouzimu": "ATGHBBD"
}, {
    "name": "澳大利亚",
    "code": "+61",
    "engName": "Australia",
    "index": "16",
    "firstWord": "A",
    "shouzimu": "ADLY"
}, {
    "name": "奥地利",
    "code": "+43",
    "engName": "Austria",
    "index": "17",
    "firstWord": "A",
    "shouzimu": "ADL"
}, {
    "name": "阿塞拜疆",
    "code": "+994",
    "engName": "Azerbaijan",
    "index": "18",
    "firstWord": "A",
    "shouzimu": "ASBJ"
}, {
    "name": "布隆迪",
    "code": "+257",
    "engName": "Burundi",
    "index": "19",
    "firstWord": "B",
    "shouzimu": "BLD"
}, {
    "name": "比利时",
    "code": "+32",
    "engName": "Belgium",
    "index": "20",
    "firstWord": "B",
    "shouzimu": "BLS"
}, {
    "name": "贝宁",
    "code": "+229",
    "engName": "Benin",
    "index": "21",
    "firstWord": "B",
    "shouzimu": "BN"
}, {
    "name": "布基纳法索",
    "code": "+226",
    "engName": "Burkina Faso",
    "index": "22",
    "firstWord": "B",
    "shouzimu": "BJNFS"
}, {
    "name": "孟加拉",
    "code": "+880",
    "engName": "Bangladesh",
    "index": "23",
    "firstWord": "M",
    "shouzimu": "MJL"
}, {
    "name": "保加利亚",
    "code": "+359",
    "engName": "Bulgaria",
    "index": "24",
    "firstWord": "B",
    "shouzimu": "BJLY"
}, {
    "name": "巴林",
    "code": "+973",
    "engName": "Bahrain",
    "index": "25",
    "firstWord": "B",
    "shouzimu": "BL"
}, {
    "name": "巴哈马",
    "code": "+1242",
    "engName": "Bahamas",
    "index": "26",
    "firstWord": "B",
    "shouzimu": "BHM"
}, {
    "name": "波斯尼亚和黑塞哥维那",
    "code": "+387",
    "engName": "Bosnia and Herz.",
    "index": "27",
    "firstWord": "B",
    "shouzimu": "BSNYHHSGWN"
}, {
    "name": "圣巴泰勒米岛",
    "code": "+290",
    "engName": "St-Barthélemy",
    "index": "29",
    "firstWord": "S",
    "shouzimu": "SBTLMD"
}, {
    "name": "白俄罗斯",
    "code": "+375",
    "engName": "Belarus",
    "index": "30",
    "firstWord": "B",
    "shouzimu": "BELS"
}, {
    "name": "伯利兹",
    "code": "+501",
    "engName": "Belize",
    "index": "31",
    "firstWord": "B",
    "shouzimu": "BLZ"
}, {
    "name": "百慕大",
    "code": "+1441",
    "engName": "Bermuda",
    "index": "32",
    "firstWord": "B",
    "shouzimu": "BMD"
}, {
    "name": "玻利维亚",
    "code": "+591",
    "engName": "Bolivia",
    "index": "33",
    "firstWord": "B",
    "shouzimu": "BLWY"
}, {
    "name": "巴西",
    "code": "+55",
    "engName": "Brazil",
    "index": "34",
    "firstWord": "B",
    "shouzimu": "BX"
}, {
    "name": "巴巴多斯",
    "code": "+1246",
    "engName": "Barbados",
    "index": "35",
    "firstWord": "B",
    "shouzimu": "BBDS"
}, {
    "name": "文莱",
    "code": "+673",
    "engName": "Brunei",
    "index": "36",
    "firstWord": "W",
    "shouzimu": "WL"
}, {
    "name": "不丹",
    "code": "+975",
    "engName": "Bhutan",
    "index": "37",
    "firstWord": "B",
    "shouzimu": "BD"
}, {
    "name": "博茨瓦纳",
    "code": "+267",
    "engName": "Botswana",
    "index": "38",
    "firstWord": "B",
    "shouzimu": "BCWN"
}, {
    "name": "中非",
    "code": "+236",
    "engName": "Central African Rep.",
    "index": "39",
    "firstWord": "Z",
    "shouzimu": "ZF"
}, {
    "name": "加拿大",
    "code": "+1",
    "engName": "Canada",
    "index": "40",
    "firstWord": "J",
    "shouzimu": "JND"
}, {
    "name": "瑞士",
    "code": "+41",
    "engName": "Switzerland",
    "index": "41",
    "firstWord": "R",
    "shouzimu": "RS"
}, {
    "name": "智利",
    "code": "+56",
    "engName": "Chile",
    "index": "42",
    "firstWord": "Z",
    "shouzimu": "ZL"
}, {
    "name": "科特迪瓦",
    "code": "+225",
    "engName": "Côte d'Ivoire",
    "index": "44",
    "firstWord": "K",
    "shouzimu": "KTDW"
}, {
    "name": "喀麦隆",
    "code": "+237",
    "engName": "Cameroon",
    "index": "46",
    "firstWord": "K",
    "shouzimu": "KML"
}, {
    "name": "刚果(金)",
    "code": "+243",
    "engName": "Dem. Rep. Congo",
    "index": "48",
    "firstWord": "G",
    "shouzimu": "GG(J)"
}, {
    "name": "刚果(布)",
    "code": "+242",
    "engName": "Congo",
    "index": "49",
    "firstWord": "G",
    "shouzimu": "GG(B)"
}, {
    "name": "库克群岛",
    "code": "+682",
    "engName": "Cook Is.",
    "index": "50",
    "firstWord": "K",
    "shouzimu": "KKQD"
}, {
    "name": "哥伦比亚",
    "code": "+57",
    "engName": "Colombia",
    "index": "51",
    "firstWord": "G",
    "shouzimu": "GLBY"
}, {
    "name": "科摩罗",
    "code": "+269",
    "engName": "Comoros",
    "index": "52",
    "firstWord": "K",
    "shouzimu": "KML"
}, {
    "name": "佛得角",
    "code": "+238",
    "engName": "Cape Verde",
    "index": "53",
    "firstWord": "F",
    "shouzimu": "FDJ"
}, {
    "name": "哥斯达黎加",
    "code": "+506",
    "engName": "Costa Rica",
    "index": "54",
    "firstWord": "G",
    "shouzimu": "GSDLJ"
}, {
    "name": "古巴",
    "code": "+53",
    "engName": "Cuba",
    "index": "56",
    "firstWord": "G",
    "shouzimu": "GB"
}, {
    "name": "库拉索",
    "code": "+5999",
    "engName": "Curaçao",
    "index": "57",
    "firstWord": "K",
    "shouzimu": "KLS"
}, {
    "name": "开曼群岛",
    "code": "+1345",
    "engName": "Cayman Is.",
    "index": "58",
    "firstWord": "K",
    "shouzimu": "KMQD"
}, {
    "name": "塞浦路斯",
    "code": "+357",
    "engName": "Cyprus",
    "index": "60",
    "firstWord": "S",
    "shouzimu": "SPLS"
}, {
    "name": "捷克",
    "code": "+420",
    "engName": "Czech Rep.",
    "index": "61",
    "firstWord": "J",
    "shouzimu": "JK"
}, {
    "name": "德国",
    "code": "+49",
    "engName": "Germany",
    "index": "62",
    "firstWord": "D",
    "shouzimu": "DG"
}, {
    "name": "吉布提",
    "code": "+253",
    "engName": "Djibouti",
    "index": "63",
    "firstWord": "J",
    "shouzimu": "JBT"
}, {
    "name": "多米尼克",
    "code": "+1767",
    "engName": "Dominica",
    "index": "64",
    "firstWord": "D",
    "shouzimu": "DMNK"
}, {
    "name": "丹麦",
    "code": "+45",
    "engName": "Denmark",
    "index": "65",
    "firstWord": "D",
    "shouzimu": "DM"
}, {
    "name": "多米尼加",
    "code": "+1809",
    "engName": "Dominican Rep.",
    "index": "66",
    "firstWord": "D",
    "shouzimu": "DMNJ"
}, {
    "name": "阿尔及利亚",
    "code": "+213",
    "engName": "Algeria",
    "index": "67",
    "firstWord": "A",
    "shouzimu": "AEJLY"
}, {
    "name": "厄瓜多尔",
    "code": "+593",
    "engName": "Ecuador",
    "index": "68",
    "firstWord": "E",
    "shouzimu": "EGDE"
}, {
    "name": "埃及",
    "code": "+20",
    "engName": "Egypt",
    "index": "69",
    "firstWord": "A",
    "shouzimu": "AJ"
}, {
    "name": "厄立特里亚",
    "code": "+291",
    "engName": "Eritrea",
    "index": "70",
    "firstWord": "E",
    "shouzimu": "ELTLY"
}, {
    "name": "西班牙",
    "code": "+34",
    "engName": "Spain",
    "index": "72",
    "firstWord": "X",
    "shouzimu": "XBY"
}, {
    "name": "爱沙尼亚",
    "code": "+372",
    "engName": "Estonia",
    "index": "73",
    "firstWord": "A",
    "shouzimu": "ASNY"
}, {
    "name": "埃塞俄比亚",
    "code": "+251",
    "engName": "Ethiopia",
    "index": "74",
    "firstWord": "A",
    "shouzimu": "ASEBY"
}, {
    "name": "芬兰",
    "code": "+358",
    "engName": "Finland",
    "index": "75",
    "firstWord": "F",
    "shouzimu": "FL"
}, {
    "name": "斐济",
    "code": "+679",
    "engName": "Fiji",
    "index": "76",
    "firstWord": "F",
    "shouzimu": "FJ"
}, {
    "name": "福克兰群岛",
    "code": "+500",
    "engName": "Falkland Is.",
    "index": "77",
    "firstWord": "F",
    "shouzimu": "FKLQD"
}, {
    "name": "法国",
    "code": "+33",
    "engName": "France",
    "index": "78",
    "firstWord": "F",
    "shouzimu": "FG"
}, {
    "name": "法罗群岛",
    "code": "+298",
    "engName": "Faeroe Is.",
    "index": "79",
    "firstWord": "F",
    "shouzimu": "FLQD"
}, {
    "name": "密克罗尼西亚联邦",
    "code": "+691",
    "engName": "Micronesia",
    "index": "80",
    "firstWord": "M",
    "shouzimu": "MKLNXYLB"
}, {
    "name": "加蓬",
    "code": "+241",
    "engName": "Gabon",
    "index": "81",
    "firstWord": "J",
    "shouzimu": "JP"
}, {
    "name": "英国",
    "code": "+44",
    "engName": "United Kingdom",
    "index": "82",
    "firstWord": "Y",
    "shouzimu": "YG"
}, {
    "name": "格鲁吉亚",
    "code": "+995",
    "engName": "Georgia",
    "index": "83",
    "firstWord": "G",
    "shouzimu": "GLJY"
}, {
    "name": "加纳",
    "code": "+233",
    "engName": "Ghana",
    "index": "85",
    "firstWord": "J",
    "shouzimu": "JN"
}, {
    "name": "直布罗陀",
    "code": "+350",
    "engName": "Gibraltar",
    "index": "86",
    "firstWord": "Z",
    "shouzimu": "ZBLT"
}, {
    "name": "几内亚",
    "code": "+224",
    "engName": "Guinea",
    "index": "87",
    "firstWord": "J",
    "shouzimu": "JNY"
}, {
    "name": "冈比亚",
    "code": "+220",
    "engName": "Gambia",
    "index": "88",
    "firstWord": "G",
    "shouzimu": "GBY"
}, {
    "name": "几内亚比绍",
    "code": "+245",
    "engName": "Guinea-Bissau",
    "index": "89",
    "firstWord": "J",
    "shouzimu": "JNYBS"
}, {
    "name": "赤道几内亚",
    "code": "+240",
    "engName": "Eq. Guinea",
    "index": "90",
    "firstWord": "C",
    "shouzimu": "CDJNY"
}, {
    "name": "希腊",
    "code": "+30",
    "engName": "Greece",
    "index": "91",
    "firstWord": "X",
    "shouzimu": "XL"
}, {
    "name": "格林纳达",
    "code": "+1473",
    "engName": "Grenada",
    "index": "92",
    "firstWord": "G",
    "shouzimu": "GLND"
}, {
    "name": "格陵兰",
    "code": "+299",
    "engName": "Greenland",
    "index": "93",
    "firstWord": "G",
    "shouzimu": "GLL"
}, {
    "name": "危地马拉",
    "code": "+502",
    "engName": "Guatemala",
    "index": "94",
    "firstWord": "W",
    "shouzimu": "WDML"
}, {
    "name": "关岛",
    "code": "+1671",
    "engName": "Guam",
    "index": "95",
    "firstWord": "G",
    "shouzimu": "GD"
}, {
    "name": "圭亚那",
    "code": "+592",
    "engName": "Guyana",
    "index": "96",
    "firstWord": "G",
    "shouzimu": "GYN"
}, {
    "name": "洪都拉斯",
    "code": "+504",
    "engName": "Honduras",
    "index": "99",
    "firstWord": "H",
    "shouzimu": "HDLS"
}, {
    "name": "克罗地亚",
    "code": "+385",
    "engName": "Croatia",
    "index": "100",
    "firstWord": "K",
    "shouzimu": "KLDY"
}, {
    "name": "海地",
    "code": "+509",
    "engName": "Haiti",
    "index": "101",
    "firstWord": "H",
    "shouzimu": "HD"
}, {
    "name": "匈牙利",
    "code": "+36",
    "engName": "Hungary",
    "index": "102",
    "firstWord": "X",
    "shouzimu": "XYL"
}, {
    "name": "印度尼西亚",
    "code": "+62",
    "engName": "Indonesia",
    "index": "103",
    "firstWord": "Y",
    "shouzimu": "YDNXY"
}, {
    "name": "印度",
    "code": "+91",
    "engName": "India",
    "index": "105",
    "firstWord": "Y",
    "shouzimu": "YD"
}, {
    "name": "英属印度洋领地",
    "code": "+246",
    "engName": "Br. Indian Ocean Ter.",
    "index": "107",
    "firstWord": "Y",
    "shouzimu": "YSYDYLD"
}, {
    "name": "爱尔兰",
    "code": "+353",
    "engName": "Ireland",
    "index": "108",
    "firstWord": "A",
    "shouzimu": "AEL"
}, {
    "name": "伊朗",
    "code": "+98",
    "engName": "Iran",
    "index": "109",
    "firstWord": "Y",
    "shouzimu": "YL"
}, {
    "name": "伊拉克",
    "code": "+964",
    "engName": "Iraq",
    "index": "110",
    "firstWord": "Y",
    "shouzimu": "YLK"
}, {
    "name": "冰岛",
    "code": "+354",
    "engName": "Iceland",
    "index": "111",
    "firstWord": "B",
    "shouzimu": "BD"
}, {
    "name": "以色列",
    "code": "+972",
    "engName": "Israel",
    "index": "112",
    "firstWord": "Y",
    "shouzimu": "YSL"
}, {
    "name": "意大利",
    "code": "+39",
    "engName": "Italy",
    "index": "113",
    "firstWord": "Y",
    "shouzimu": "YDL"
}, {
    "name": "牙买加",
    "code": "+1876",
    "engName": "Jamaica",
    "index": "114",
    "firstWord": "Y",
    "shouzimu": "YMJ"
}, {
    "name": "约旦",
    "code": "+962",
    "engName": "Jordan",
    "index": "116",
    "firstWord": "Y",
    "shouzimu": "YD"
}, {
    "name": "日本",
    "code": "+81",
    "engName": "Japan",
    "index": "117",
    "firstWord": "R",
    "shouzimu": "RB"
}, {
    "name": "哈萨克斯坦",
    "code": "+327",
    "engName": "Kazakhstan",
    "index": "120",
    "firstWord": "H",
    "shouzimu": "HSKST"
}, {
    "name": "肯尼亚",
    "code": "+254",
    "engName": "Kenya",
    "index": "121",
    "firstWord": "K",
    "shouzimu": "KNY"
}, {
    "name": "吉尔吉斯斯坦",
    "code": "+331",
    "engName": "Kyrgyzstan",
    "index": "122",
    "firstWord": "J",
    "shouzimu": "JEJSST"
}, {
    "name": "柬埔寨",
    "code": "+855",
    "engName": "Cambodia",
    "index": "123",
    "firstWord": "J",
    "shouzimu": "JPZ"
}, {
    "name": "基里巴斯",
    "code": "+686",
    "engName": "Kiribati",
    "index": "124",
    "firstWord": "J",
    "shouzimu": "JLBS"
}, {
    "name": "圣基茨和尼维斯",
    "code": "+1869",
    "engName": "St. Kitts and Nevis",
    "index": "125",
    "firstWord": "S",
    "shouzimu": "SJCHNWS"
}, {
    "name": "韩国",
    "code": "+82",
    "engName": "Korea",
    "index": "126",
    "firstWord": "H",
    "shouzimu": "HG"
}, {
    "name": "科索沃",
    "code": "+384",
    "engName": "Kosovo",
    "index": "127",
    "firstWord": "K",
    "shouzimu": "KSW"
}, {
    "name": "科威特",
    "code": "+965",
    "engName": "Kuwait",
    "index": "128",
    "firstWord": "K",
    "shouzimu": "KWT"
}, {
    "name": "老挝",
    "code": "+856",
    "engName": "Lao PDR",
    "index": "129",
    "firstWord": "L",
    "shouzimu": "LW"
}, {
    "name": "黎巴嫩",
    "code": "+961",
    "engName": "Lebanon",
    "index": "130",
    "firstWord": "L",
    "shouzimu": "LBN"
}, {
    "name": "利比里亚",
    "code": "+231",
    "engName": "Liberia",
    "index": "131",
    "firstWord": "L",
    "shouzimu": "LBLY"
}, {
    "name": "利比亚",
    "code": "+218",
    "engName": "Libya",
    "index": "132",
    "firstWord": "L",
    "shouzimu": "LBY"
}, {
    "name": "圣卢西亚",
    "code": "+1758",
    "engName": "Saint Lucia",
    "index": "133",
    "firstWord": "S",
    "shouzimu": "SLXY"
}, {
    "name": "列支敦士登",
    "code": "+423",
    "engName": "Liechtenstein",
    "index": "134",
    "firstWord": "L",
    "shouzimu": "LZDSD"
}, {
    "name": "斯里兰卡",
    "code": "+94",
    "engName": "Sri Lanka",
    "index": "135",
    "firstWord": "S",
    "shouzimu": "SLLK"
}, {
    "name": "莱索托",
    "code": "+266",
    "engName": "Lesotho",
    "index": "136",
    "firstWord": "L",
    "shouzimu": "LST"
}, {
    "name": "立陶宛",
    "code": "+370",
    "engName": "Lithuania",
    "index": "137",
    "firstWord": "L",
    "shouzimu": "LTW"
}, {
    "name": "卢森堡",
    "code": "+352",
    "engName": "Luxembourg",
    "index": "138",
    "firstWord": "L",
    "shouzimu": "LSB"
}, {
    "name": "拉脱维亚",
    "code": "+371",
    "engName": "Latvia",
    "index": "139",
    "firstWord": "L",
    "shouzimu": "LTWY"
}, {
    "name": "法属圣马丁",
    "code": "+1599",
    "engName": "St-Martin",
    "index": "141",
    "firstWord": "F",
    "shouzimu": "FSSMD"
}, {
    "name": "摩洛哥",
    "code": "+212",
    "engName": "Morocco",
    "index": "142",
    "firstWord": "M",
    "shouzimu": "MLG"
}, {
    "name": "摩纳哥",
    "code": "+377",
    "engName": "Monaco",
    "index": "143",
    "firstWord": "M",
    "shouzimu": "MNG"
}, {
    "name": "摩尔多瓦",
    "code": "+373",
    "engName": "Moldova",
    "index": "144",
    "firstWord": "M",
    "shouzimu": "MEDW"
}, {
    "name": "马达加斯加",
    "code": "+261",
    "engName": "Madagascar",
    "index": "145",
    "firstWord": "M",
    "shouzimu": "MDJSJ"
}, {
    "name": "马尔代夫",
    "code": "+960",
    "engName": "Maldives",
    "index": "146",
    "firstWord": "M",
    "shouzimu": "MEDF"
}, {
    "name": "墨西哥",
    "code": "+52",
    "engName": "Mexico",
    "index": "147",
    "firstWord": "M",
    "shouzimu": "MXG"
}, {
    "name": "马绍尔群岛",
    "code": "+692",
    "engName": "Marshall Is.",
    "index": "148",
    "firstWord": "M",
    "shouzimu": "MSEQD"
}, {
    "name": "马其顿",
    "code": "+389",
    "engName": "Macedonia",
    "index": "149",
    "firstWord": "M",
    "shouzimu": "MQD"
}, {
    "name": "马里",
    "code": "+223",
    "engName": "Mali",
    "index": "150",
    "firstWord": "M",
    "shouzimu": "ML"
}, {
    "name": "马耳他",
    "code": "+356",
    "engName": "Malta",
    "index": "151",
    "firstWord": "M",
    "shouzimu": "MET"
}, {
    "name": "缅甸",
    "code": "+95",
    "engName": "Myanmar",
    "index": "152",
    "firstWord": "M",
    "shouzimu": "MD"
}, {
    "name": "黑山",
    "code": "+382",
    "engName": "Montenegro",
    "index": "153",
    "firstWord": "H",
    "shouzimu": "HS"
}, {
    "name": "蒙古",
    "code": "+976",
    "engName": "Mongolia",
    "index": "154",
    "firstWord": "M",
    "shouzimu": "MG"
}, {
    "name": "北马里亚纳群岛",
    "code": "+1670",
    "engName": "N. Mariana Is.",
    "index": "155",
    "firstWord": "B",
    "shouzimu": "BMLYNQD"
}, {
    "name": "莫桑比克",
    "code": "+258",
    "engName": "Mozambique",
    "index": "156",
    "firstWord": "M",
    "shouzimu": "MSBK"
}, {
    "name": "毛里塔尼亚",
    "code": "+222",
    "engName": "Mauritania",
    "index": "157",
    "firstWord": "M",
    "shouzimu": "MLTNY"
}, {
    "name": "蒙塞拉特岛",
    "code": "+1664",
    "engName": "Montserrat",
    "index": "158",
    "firstWord": "M",
    "shouzimu": "MSLTD"
}, {
    "name": "毛里求斯",
    "code": "+230",
    "engName": "Mauritius",
    "index": "159",
    "firstWord": "M",
    "shouzimu": "MLQS"
}, {
    "name": "马拉维",
    "code": "+265",
    "engName": "Malawi",
    "index": "160",
    "firstWord": "M",
    "shouzimu": "MLW"
}, {
    "name": "马来西亚",
    "code": "+60",
    "engName": "Malaysia",
    "index": "161",
    "firstWord": "M",
    "shouzimu": "MLXY"
}, {
    "name": "纳米比亚",
    "code": "+264",
    "engName": "Namibia",
    "index": "162",
    "firstWord": "N",
    "shouzimu": "NMBY"
}, {
    "name": "新喀里多尼亚",
    "code": "+687",
    "engName": "New Caledonia",
    "index": "163",
    "firstWord": "X",
    "shouzimu": "XKLDNY"
}, {
    "name": "尼日尔",
    "code": "+227",
    "engName": "Niger",
    "index": "164",
    "firstWord": "N",
    "shouzimu": "NRE"
}, {
    "name": "诺福克岛",
    "code": "+672",
    "engName": "Norfolk Island",
    "index": "165",
    "firstWord": "N",
    "shouzimu": "NFKD"
}, {
    "name": "尼日利亚",
    "code": "+234",
    "engName": "Nigeria",
    "index": "166",
    "firstWord": "N",
    "shouzimu": "NRLY"
}, {
    "name": "尼加拉瓜",
    "code": "+505",
    "engName": "Nicaragua",
    "index": "167",
    "firstWord": "N",
    "shouzimu": "NJLG"
}, {
    "name": "纽埃岛",
    "code": "+683",
    "engName": "Niue",
    "index": "168",
    "firstWord": "N",
    "shouzimu": "NAD"
}, {
    "name": "荷兰",
    "code": "+31",
    "engName": "Netherlands",
    "index": "169",
    "firstWord": "H",
    "shouzimu": "HL"
}, {
    "name": "挪威",
    "code": "+47",
    "engName": "Norway",
    "index": "170",
    "firstWord": "N",
    "shouzimu": "NW"
}, {
    "name": "尼泊尔",
    "code": "+977",
    "engName": "Nepal",
    "index": "171",
    "firstWord": "N",
    "shouzimu": "NBE"
}, {
    "name": "瑙鲁",
    "code": "+674",
    "engName": "Nauru",
    "index": "172",
    "firstWord": "N",
    "shouzimu": "NL"
}, {
    "name": "新西兰",
    "code": "+64",
    "engName": "New Zealand",
    "index": "173",
    "firstWord": "X",
    "shouzimu": "XXL"
}, {
    "name": "阿曼",
    "code": "+968",
    "engName": "Oman",
    "index": "174",
    "firstWord": "A",
    "shouzimu": "AM"
}, {
    "name": "巴基斯坦",
    "code": "+92",
    "engName": "Pakistan",
    "index": "175",
    "firstWord": "B",
    "shouzimu": "BJST"
}, {
    "name": "巴拿马",
    "code": "+507",
    "engName": "Panama",
    "index": "176",
    "firstWord": "B",
    "shouzimu": "BNM"
}, {
    "name": "秘鲁",
    "code": "+51",
    "engName": "Peru",
    "index": "178",
    "firstWord": "B",
    "shouzimu": "BL"
}, {
    "name": "菲律宾",
    "code": "+63",
    "engName": "Philippines",
    "index": "180",
    "firstWord": "F",
    "shouzimu": "FLB"
}, {
    "name": "帕劳",
    "code": "+680",
    "engName": "Palau",
    "index": "181",
    "firstWord": "P",
    "shouzimu": "PL"
}, {
    "name": "巴布亚新几内亚",
    "code": "+675",
    "engName": "Papua New Guinea",
    "index": "182",
    "firstWord": "B",
    "shouzimu": "BBYXJNY"
}, {
    "name": "波兰",
    "code": "+48",
    "engName": "Poland",
    "index": "183",
    "firstWord": "B",
    "shouzimu": "BL"
}, {
    "name": "波多黎各",
    "code": "+1787",
    "engName": "Puerto Rico",
    "index": "184",
    "firstWord": "B",
    "shouzimu": "BDLG"
}, {
    "name": "朝鲜",
    "code": "+850",
    "engName": "Dem. Rep. Korea",
    "index": "185",
    "firstWord": "C",
    "shouzimu": "CX"
}, {
    "name": "葡萄牙",
    "code": "+351",
    "engName": "Portugal",
    "index": "186",
    "firstWord": "P",
    "shouzimu": "PTY"
}, {
    "name": "巴拉圭",
    "code": "+595",
    "engName": "Paraguay",
    "index": "187",
    "firstWord": "B",
    "shouzimu": "BLG"
}, {
    "name": "巴勒斯坦",
    "code": "+970",
    "engName": "Palestine",
    "index": "188",
    "firstWord": "B",
    "shouzimu": "BLST"
}, {
    "name": "法属波利尼西亚",
    "code": "+689",
    "engName": "Fr. Polynesia",
    "index": "189",
    "firstWord": "F",
    "shouzimu": "FSBLNXY"
}, {
    "name": "卡塔尔",
    "code": "+974",
    "engName": "Qatar",
    "index": "190",
    "firstWord": "K",
    "shouzimu": "KTE"
}, {
    "name": "罗马尼亚",
    "code": "+40",
    "engName": "Romania",
    "index": "191",
    "firstWord": "L",
    "shouzimu": "LMNY"
}, {
    "name": "俄罗斯",
    "code": "+7",
    "engName": "Russia",
    "index": "192",
    "firstWord": "E",
    "shouzimu": "ELS"
}, {
    "name": "卢旺达",
    "code": "+250",
    "engName": "Rwanda",
    "index": "193",
    "firstWord": "L",
    "shouzimu": "LWD"
}, {
    "name": "沙特阿拉伯",
    "code": "+966",
    "engName": "Saudi Arabia",
    "index": "195",
    "firstWord": "S",
    "shouzimu": "STALB"
}, {
    "name": "苏丹",
    "code": "+249",
    "engName": "Sudan",
    "index": "197",
    "firstWord": "S",
    "shouzimu": "SD"
}, {
    "name": "南苏丹",
    "code": "+211",
    "engName": "S. Sudan",
    "index": "198",
    "firstWord": "N",
    "shouzimu": "NSD"
}, {
    "name": "塞内加尔",
    "code": "+221",
    "engName": "Senegal",
    "index": "199",
    "firstWord": "S",
    "shouzimu": "SNJE"
}, {
    "name": "新加坡",
    "code": "+65",
    "engName": "Singapore",
    "index": "201",
    "firstWord": "X",
    "shouzimu": "XJP"
}, {
    "name": "所罗门群岛",
    "code": "+677",
    "engName": "Solomon Is.",
    "index": "204",
    "firstWord": "S",
    "shouzimu": "SLMQD"
}, {
    "name": "塞拉利昂",
    "code": "+232",
    "engName": "Sierra Leone",
    "index": "205",
    "firstWord": "S",
    "shouzimu": "SLLA"
}, {
    "name": "萨尔瓦多",
    "code": "+503",
    "engName": "El Salvador",
    "index": "206",
    "firstWord": "S",
    "shouzimu": "SEWD"
}, {
    "name": "圣马力诺",
    "code": "+378",
    "engName": "San Marino",
    "index": "207",
    "firstWord": "S",
    "shouzimu": "SMLN"
}, {
    "name": "索马里",
    "code": "+252",
    "engName": "Somalia",
    "index": "209",
    "firstWord": "S",
    "shouzimu": "SML"
}, {
    "name": "圣皮埃尔和密克隆群岛",
    "code": "+508",
    "engName": "St. Pierre and Miquelon",
    "index": "210",
    "firstWord": "S",
    "shouzimu": "SPAEHMKLQD"
}, {
    "name": "塞尔维亚",
    "code": "+381",
    "engName": "Serbia",
    "index": "211",
    "firstWord": "S",
    "shouzimu": "SEWY"
}, {
    "name": "圣多美和普林西比",
    "code": "+239",
    "engName": "São Tomé and Principe",
    "index": "212",
    "firstWord": "S",
    "shouzimu": "SDMHPLXB"
}, {
    "name": "苏里南",
    "code": "+597",
    "engName": "Suriname",
    "index": "213",
    "firstWord": "S",
    "shouzimu": "SLN"
}, {
    "name": "斯洛伐克",
    "code": "+421",
    "engName": "Slovakia",
    "index": "214",
    "firstWord": "S",
    "shouzimu": "SLFK"
}, {
    "name": "斯洛文尼亚",
    "code": "+386",
    "engName": "Slovenia",
    "index": "215",
    "firstWord": "S",
    "shouzimu": "SLWNY"
}, {
    "name": "瑞典",
    "code": "+46",
    "engName": "Sweden",
    "index": "216",
    "firstWord": "R",
    "shouzimu": "RD"
}, {
    "name": "斯威士兰",
    "code": "+268",
    "engName": "Swaziland",
    "index": "217",
    "firstWord": "S",
    "shouzimu": "SWSL"
}, {
    "name": "荷属圣马丁",
    "code": "+1721",
    "engName": "Sint Maarten",
    "index": "218",
    "firstWord": "H",
    "shouzimu": "HSSMD"
}, {
    "name": "塞舌尔",
    "code": "+248",
    "engName": "Seychelles",
    "index": "219",
    "firstWord": "S",
    "shouzimu": "SSE"
}, {
    "name": "叙利亚",
    "code": "+963",
    "engName": "Syria",
    "index": "220",
    "firstWord": "X",
    "shouzimu": "XLY"
}, {
    "name": "特克斯和凯科斯群岛",
    "code": "+1649",
    "engName": "Turks and Caicos Is.",
    "index": "221",
    "firstWord": "T",
    "shouzimu": "TKSHKKSQD"
}, {
    "name": "乍得",
    "code": "+235",
    "engName": "Chad",
    "index": "222",
    "firstWord": "Z",
    "shouzimu": "ZD"
}, {
    "name": "多哥",
    "code": "+228",
    "engName": "Togo",
    "index": "223",
    "firstWord": "D",
    "shouzimu": "DG"
}, {
    "name": "泰国",
    "code": "+66",
    "engName": "Thailand",
    "index": "224",
    "firstWord": "T",
    "shouzimu": "TG"
}, {
    "name": "塔吉克斯坦",
    "code": "+992",
    "engName": "Tajikistan",
    "index": "225",
    "firstWord": "T",
    "shouzimu": "TJKST"
}, {
    "name": "土库曼斯坦",
    "code": "+993",
    "engName": "Turkmenistan",
    "index": "226",
    "firstWord": "T",
    "shouzimu": "TKMST"
}, {
    "name": "东帝汶",
    "code": "+670",
    "engName": "Timor-Leste",
    "index": "227",
    "firstWord": "D",
    "shouzimu": "DDW"
}, {
    "name": "汤加",
    "code": "+676",
    "engName": "Tonga",
    "index": "228",
    "firstWord": "T",
    "shouzimu": "TJ"
}, {
    "name": "特立尼达和多巴哥",
    "code": "+1868",
    "engName": "Trinidad and Tobago",
    "index": "229",
    "firstWord": "T",
    "shouzimu": "TLNDHDBG"
}, {
    "name": "突尼斯",
    "code": "+216",
    "engName": "Tunisia",
    "index": "230",
    "firstWord": "T",
    "shouzimu": "TNS"
}, {
    "name": "土耳其",
    "code": "+90",
    "engName": "Turkey",
    "index": "231",
    "firstWord": "T",
    "shouzimu": "TEQ"
}, {
    "name": "图瓦卢",
    "code": "+688",
    "engName": "Tuvalu",
    "index": "232",
    "firstWord": "T",
    "shouzimu": "TWL"
}, {
    "name": "坦桑尼亚",
    "code": "+255",
    "engName": "Tanzania",
    "index": "234",
    "firstWord": "T",
    "shouzimu": "TSNY"
}, {
    "name": "乌干达",
    "code": "+256",
    "engName": "Uganda",
    "index": "235",
    "firstWord": "W",
    "shouzimu": "WGD"
}, {
    "name": "乌克兰",
    "code": "+380",
    "engName": "Ukraine",
    "index": "236",
    "firstWord": "W",
    "shouzimu": "WKL"
}, {
    "name": "乌拉圭",
    "code": "+598",
    "engName": "Uruguay",
    "index": "238",
    "firstWord": "W",
    "shouzimu": "WLG"
}, {
    "name": "美国",
    "code": "+1",
    "engName": "United States",
    "index": "239",
    "firstWord": "M",
    "shouzimu": "MG"
}, {
    "name": "乌兹别克斯坦",
    "code": "+233",
    "engName": "Uzbekistan",
    "index": "241",
    "firstWord": "W",
    "shouzimu": "WZBKST"
}, {
    "name": "梵蒂冈",
    "code": "+39",
    "engName": "Vatican",
    "index": "242",
    "firstWord": "F",
    "shouzimu": "FDG"
}, {
    "name": "圣文森特和格林纳丁斯",
    "code": "+1784",
    "engName": "St. Vin. and Gren.",
    "index": "243",
    "firstWord": "S",
    "shouzimu": "SWSTHGLNDS"
}, {
    "name": "委内瑞拉",
    "code": "+58",
    "engName": "Venezuela",
    "index": "244",
    "firstWord": "W",
    "shouzimu": "WNRL"
}, {
    "name": "英属维尔京群岛",
    "code": "+1284",
    "engName": "British Virgin Is.",
    "index": "245",
    "firstWord": "Y",
    "shouzimu": "YSWEJQD"
}, {
    "name": "美属维尔京群岛",
    "code": "+1340",
    "engName": "U.S. Virgin Is.",
    "index": "246",
    "firstWord": "M",
    "shouzimu": "MSWEJQD"
}, {
    "name": "越南",
    "code": "+84",
    "engName": "Vietnam",
    "index": "247",
    "firstWord": "Y",
    "shouzimu": "YN"
}, {
    "name": "瓦努阿图",
    "code": "+678",
    "engName": "Vanuatu",
    "index": "248",
    "firstWord": "W",
    "shouzimu": "WNAT"
}, {
    "name": "瓦利斯和富图纳群岛",
    "code": "+681",
    "engName": "Wallis and Futuna Is.",
    "index": "249",
    "firstWord": "W",
    "shouzimu": "WLSHFTNQD"
}, {
    "name": "萨摩亚",
    "code": "+685",
    "engName": "Samoa",
    "index": "251",
    "firstWord": "S",
    "shouzimu": "SMY"
}, {
    "name": "也门",
    "code": "+967",
    "engName": "Yemen",
    "index": "252",
    "firstWord": "Y",
    "shouzimu": "YM"
}, {
    "name": "南非",
    "code": "+27",
    "engName": "South Africa",
    "index": "253",
    "firstWord": "N",
    "shouzimu": "NF"
}, {
    "name": "赞比亚",
    "code": "+260",
    "engName": "Zambia",
    "index": "254",
    "firstWord": "Z",
    "shouzimu": "ZBY"
}, {
    "name": "津巴布韦",
    "code": "+263",
    "engName": "Zimbabwe",
    "index": "255",
    "firstWord": "J",
    "shouzimu": "JBBW"
}, {
    "name": "亚什摩及卡地尔群岛",
    "code": "+61",
    "engName": "Ashmore and Cartier Is.",
    "index": "13",
    "firstWord": "Y",
    "shouzimu": "YSMJKDEQD"
}, {
    "name": "法属南部领土",
    "code": "+262",
    "engName": "Fr. S. Antarctic Lands",
    "index": "14",
    "firstWord": "F",
    "shouzimu": "FSNBLT"
}, {
    "name": "克利珀顿岛",
    "code": "+262",
    "engName": "Clipperton I.",
    "index": "45",
    "firstWord": "K",
    "shouzimu": "KLPDD"
}, {
    "name": "塞浦路斯联合国缓冲区",
    "code": "+357",
    "engName": "Cyprus U.N. Buffer Zone",
    "index": "47",
    "firstWord": "S",
    "shouzimu": "SPLSLHGHCQ"
}, {
    "name": "珊瑚海群岛",
    "code": "+43",
    "engName": "Coral Sea Is.",
    "index": "55",
    "firstWord": "S",
    "shouzimu": "SHHQD"
}, {
    "name": "德凯利亚",
    "code": "+44",
    "engName": "Dhekelia",
    "index": "71",
    "firstWord": "D",
    "shouzimu": "DKLY"
}, {
    "name": "中国香港",
    "code": "+852",
    "engName": "Hong Kong",
    "index": "97",
    "firstWord": "Z",
    "shouzimu": "ZGXG",
    "hot": true
}, {
    "name": "赫德岛和麦克唐纳岛",
    "code": "+672",
    "engName": "Heard I. and McDonald Is.",
    "index": "98",
    "firstWord": "H",
    "shouzimu": "HDDHMKTND"
}, {
    "name": "印度洋领地",
    "code": "+246",
    "engName": "Indian Ocean Ter.",
    "index": "106",
    "firstWord": "Y",
    "shouzimu": "YDYLD"
}, {
    "name": "拜科努尔",
    "code": "+77",
    "engName": "Baikonur",
    "index": "118",
    "firstWord": "B",
    "shouzimu": "BKNE"
}, {
    "name": "中国澳门",
    "code": "+853",
    "engName": "Macao",
    "index": "140",
    "firstWord": "Z",
    "shouzimu": "ZGAM",
    "hot": true
}, {
    "name": "皮特克恩岛",
    "code": "+1",
    "engName": "Pitcairn Is.",
    "index": "177",
    "firstWord": "P",
    "shouzimu": "PTKED"
}, {
    "name": "南沙群岛",
    "code": "+86",
    "engName": "pratly Is.",
    "index": "179",
    "firstWord": "N",
    "shouzimu": "NSQD"
}, {
    "name": "西撒哈拉",
    "code": "+212",
    "engName": "W. Sahara",
    "index": "194",
    "firstWord": "X",
    "shouzimu": "XSHL"
}, {
    "name": "南乔治亚岛和南桑德韦奇岛",
    "code": "+1",
    "engName": "S. Geo. and S. Sandw. Is.",
    "index": "202",
    "firstWord": "N",
    "shouzimu": "NQZYDHNSDWQD"
}, {
    "name": "圣赫勒拿",
    "code": "+1",
    "engName": "Saint Helena",
    "index": "203",
    "firstWord": "S",
    "shouzimu": "SHLN"
}, {
    "name": "索马里兰",
    "code": "+252",
    "engName": "Somaliland",
    "index": "208",
    "firstWord": "S",
    "shouzimu": "SMLL"
}, {
    "name": "中国台湾",
    "code": "+886",
    "engName": "Taiwan",
    "index": "233",
    "firstWord": "Z",
    "shouzimu": "ZGTW",
    "hot": true
}, {
    "name": "美国本土外小岛屿",
    "code": "+1",
    "engName": "U.S. Minor Outlying Is.",
    "index": "237",
    "firstWord": "M",
    "shouzimu": "MGBTWXDY"
}, {
    "name": "关塔那摩湾",
    "code": "+1",
    "engName": "USNB Guantanamo Bay",
    "index": "240",
    "firstWord": "G",
    "shouzimu": "GTNMW"
}, {
    "name": "阿克罗蒂里",
    "code": "+357",
    "engName": "Akrotiri",
    "index": "250",
    "firstWord": "A",
    "shouzimu": "AKLDL"
}]);

/***/ }),

/***/ "IXwF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J7G2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"code-wrapper"},[_c('transition',{attrs:{"name":"imageCode","mode":"out-in"}},[(_vm.codeVisible)?_c('div',{staticClass:"check-code__container"},[_c('div',{staticClass:"check-code__title"},[_vm._v("验证码")]),_vm._v(" "),_c('form',{staticClass:"check-code__form",on:{"submit":function (e) { return e.preventDefault(); }}},[_c('div',{staticClass:"form-row"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.imageCode),expression:"imageCode"}],staticClass:"check-code__input",attrs:{"placeholder":"请输入验证码"},domProps:{"value":(_vm.imageCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.imageCode=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"check-code__img",style:('background-image: ' + 'url(' + _vm.checkCodeUrl + ');')}),_vm._v(" "),_c('div',{staticClass:"btn check-code__change",on:{"click":_vm._changeCheckCodeImg}},[_vm._v("换一张")]),_vm._v(" "),_c('div',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg))])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"btn btn-cancel",on:{"click":_vm.close}},[_vm._v("取消")]),_vm._v(" "),_c('div',{staticClass:"btn btn-confirm",attrs:{"type":"button"},on:{"click":_vm._confirmCheckCode}},[_vm._v("确认")])])])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JaHG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = queryHref;
function queryHref(key) {
  var data = window.location.href.split('?');
  var value = null;
  if (!data[1]) {
    return null;
  }
  data = data[1].split('&');
  data.forEach(function (str) {
    var arr = str.split('=');
    if (key === arr[0]) {
      value = arr[1];
    }
  });
  return value;
}

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19b8c7d9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Eomh");
function injectStyle (ssrContext) {
  __webpack_require__("IXwF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19b8c7d9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex__ = __webpack_require__("l+I4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_css__ = __webpack_require__("cilB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__index_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// document.domain="test.ximalaya.com"






__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  store: __WEBPACK_IMPORTED_MODULE_3__vuex__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "O+Gv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qrcode_login_vue__ = __webpack_require__("e0Ax");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c24c5cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_qrcode_login_vue__ = __webpack_require__("EImY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_qrcode_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c24c5cd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_qrcode_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OamE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.bindStatus !== 'NO_BIND'),expression:"bindStatus !== 'NO_BIND'"}],staticClass:"pop",attrs:{"id":"bind-phone-pop"},on:{"click":function($event){$event.stopPropagation();_vm.showCodeList = false}}},[_c('div',{staticClass:"maskers"}),_vm._v(" "),_c('transition',{attrs:{"name":"bind","mode":"out-in"}},[(_vm.bindStatus === 'TO_BIND')?_c('div',{key:'TO_BIND',staticClass:"identy-pop bind-phone"},[_c('p',{staticClass:"c09 txt-mid2 mgt-30"},[_vm._v("\n              根据《中华人民共和国网路安全法》要求，自6月1日起使用信息发布、即时通讯等互联网服务需进行身份信息验证。为保障您的使用体验，建议您尽快完成手机号绑定验证，感谢您的支持和理解。\n          ")]),_vm._v(" "),_c('div',{staticClass:"tit-panel1"},[_c('span',{staticClass:"tit"},[_vm._v("请绑定手机号")])]),_vm._v(" "),_c('div',{staticClass:"cont"},[_c('div',{staticClass:"selecter selecter-s5 selecter-m1 wid-110",class:{'open': _vm.showCodeList},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.toggleCodeList($event)}}},[_c('div',{staticClass:"selecter-selected"},[_c('span',{staticClass:"selecter-text"},[_vm._v(_vm._s(_vm.code))]),_vm._v(" "),_c('span',{staticClass:"sel-arrDu"},[_c('span',{staticClass:"icon-ic_down iconfont",attrs:{"href":""}})])]),_vm._v(" "),_c('div',{staticClass:"selecter-options"},[_c('ul',_vm._l((_vm.codeList),function(item,index){return _c('li',{staticClass:"selecter-item",on:{"click":function($event){_vm.selectCode(item)}}},[_vm._v(_vm._s(item.code))])}))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.account),expression:"user.account"}],staticClass:"txt-phone fr",attrs:{"type":"text","placeholder":"请输入手机号码"},domProps:{"value":(_vm.user.account)},on:{"blur":_vm.checkAccount,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "account", $event.target.value)}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.verify.account && _vm.jerror.account),expression:"!verify.account && jerror.account"}],staticClass:"txt-errors mgl-120"},[_vm._v(_vm._s(_vm.jerror.account))])]),_vm._v(" "),_c('div',{staticClass:"cont"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.checkCode),expression:"user.checkCode"}],staticClass:"txt-phone",attrs:{"type":"text","placeholder":"请填写短信验证码"},domProps:{"value":(_vm.user.checkCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "checkCode", $event.target.value)}}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.jerror.checkCode && !_vm.verify.checkCode),expression:"jerror.checkCode && !verify.checkCode"}],staticClass:"txt-errors"},[_vm._v(_vm._s(_vm.jerror.checkCode))]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary txt-code fr",class:{'disabled' : _vm.hasQrCode },attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.getQrCode($event)}}},[_vm._v(_vm._s(_vm.hasQrCode ? (_vm.countDown + "s") : '获取验证码'))])]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary block btn-sure",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.confirm($event)}}},[_vm._v("确定")])]):_vm._e(),_vm._v(" "),(_vm.bindStatus === 'BIND_FAILED')?_c('div',{key:'BIND_FAILED',staticClass:"identy-pop bind-phone"},[_c('span',{staticClass:"inl-b err-cat"}),_vm._v(" "),_c('p',{staticClass:"err-txt"},[_c('span',{staticClass:"iconfont icon-ic_test2 err-tip"}),_vm._v(" "),_c('span',{staticClass:"inl-b tc"},[_vm._v("该手机已绑定过多账号，"),_c('br'),_vm._v("请更换其他手机号")])]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary txt-code mgb-15",attrs:{"href":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.toRebind($event)}}},[_vm._v("重新绑定")])]):_vm._e(),_vm._v(" "),(_vm.bindStatus === 'BIND_SUCCESS')?_c('div',{key:'BIND_FAILED',staticClass:"identy-pop bind-phone"},[_c('span',{staticClass:"inl-b suc-cat"}),_vm._v(" "),_c('p',{staticClass:"suc-txt"},[_c('span',{staticClass:"iconfont icon-hook suc-tip"}),_vm._v("绑定成功\n        ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary txt-code mgb-15",attrs:{"href":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.confirmSuc($event)}}},[_vm._v("知道啦")])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PrrX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"regForm j-loginform"},[_c('input',{attrs:{"type":"hidden","id":"fromUri","name":"fromUri","value":""}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","id":"tip","name":"tip","value":""}}),_vm._v(" "),_c('div',{staticClass:"regIcLt inl-b j-coutryarea"},[_c('div',{staticClass:"regSelBox regInput inl-b wid-120",class:{'open': _vm.showCoutries},on:{"click":function($event){$event.stopPropagation();return _vm.toggleCoutries($event)}}},[_c('span',{staticClass:"wid-30 elli inl-b j-selected-name"},[_vm._v(_vm._s(_vm.coutry))]),_vm._v(" "),_c('span',{staticClass:"regSelBtn",attrs:{"data-code":_vm.code}},[_c('span',{staticClass:"j-selected-code"},[_vm._v(_vm._s(_vm.code))]),_c('i',{staticClass:"iconfont icon-ic_down"})]),_vm._v(" "),_c('div',{staticClass:"regListBox"},[_c('div',{ref:"regCodeList",staticClass:"regSelList"},[_c('ul',_vm._l((_vm.coutries),function(item,index){return _c('li',{on:{"click":function($event){_vm.selectCoutry(item)}}},[_c('span',{staticClass:"fr regSelNum"},[_vm._v(_vm._s(item.code))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))])])}))])])])]),_vm._v(" "),_c('div',{staticClass:"regIcLt inl-b fr"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.account),expression:"user.account"}],staticClass:"regInput wid-170 pdl-50",attrs:{"type":"text","name":"account","id":"userAccount","placeholder":"请输入您的账号/手机号/邮箱"},domProps:{"value":(_vm.user.account)},on:{"blur":_vm.checkAccount,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "account", $event.target.value)}}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-nickname"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.verify.account && _vm.jerror.account),expression:"!verify.account && jerror.account"}],staticClass:"regErrTex j-error"},[_vm._v(_vm._s(_vm.jerror.account))])]),_vm._v(" "),_c('div',{staticClass:"regIcLt"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.password),expression:"user.password"}],staticClass:"regInput pdl-50 wid-300",attrs:{"type":"password","name":"password","id":"userPwd","placeholder":"请输入6-20位密码"},domProps:{"value":(_vm.user.password)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submit($event)},"blur":_vm.checkPassword,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "password", $event.target.value)}}}),_vm._v(" "),_c('i',{staticClass:"iconfont icon-password"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.jerror.password && !_vm.verify.password),expression:"jerror.password && !verify.password"}],staticClass:"regErrTex j-error"},[_vm._v(_vm._s(_vm.jerror.password))])]),_vm._v(" "),_c('div',{staticClass:"regAgreeWrap"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.rememberMe),expression:"user.rememberMe"}],staticClass:"icon-checkbox",attrs:{"type":"checkbox","id":"xmlyReg","checked":""},domProps:{"checked":Array.isArray(_vm.user.rememberMe)?_vm._i(_vm.user.rememberMe,null)>-1:(_vm.user.rememberMe)},on:{"change":function($event){var $$a=_vm.user.rememberMe,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.user, "rememberMe", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.user, "rememberMe", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.user, "rememberMe", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"regCheckLab",attrs:{"for":"xmlyReg"},on:{"click":_vm.rememberLogin}},[_c('span',{staticClass:"checkIcon"}),_vm._v("记住登录状态")]),_vm._v(" "),_c('a',{staticClass:"c10 mgl-20",attrs:{"href":"/passport/user_info/show"},on:{"click":_vm.findPassword}},[_vm._v("找回密码")])]),_vm._v(" "),_c('div',{staticClass:"error"},[_vm._v(" ")]),_vm._v(" "),_c('a',{staticClass:"regSubmit",class:{'disabled': !_vm.canSubmit},attrs:{"id":"login_btn"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.submit($event)}}},[_vm._v("登录")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aYl9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var pathPrefix = '/xmcaptcha-service';
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      errorMsg: '',
      checkCodeUrl: '',
      imageCode: ''
    };
  },

  computed: {
    codeVisible: function codeVisible() {
      return this.$store.state.imageCodeVisible;
    },
    imageCodeURL: function imageCodeURL() {
      return this.$store.state.imageCodeURL;
    },
    token: function token() {
      return this.$store.state.imageCodeToken;
    },
    captchaInfo: function captchaInfo() {
      return this.$store.state.captchaInfo;
    }
  },
  watch: {
    imageCodeURL: function imageCodeURL(val) {
      this.checkCodeUrl = val;
    },
    codeVisible: function codeVisible(v) {
      if (!v) {
        this.resetForm();
      }
    }
  },
  methods: {
    resetForm: function resetForm() {
      this.imageCode = '';
      this.errorMsg = '';
    },
    _changeCheckCodeImg: function _changeCheckCodeImg() {
      this.checkCodeUrl = this.imageCodeURL + '?ts=' + Date.now();
    },
    _confirmCheckCode: function _confirmCheckCode() {
      var _this = this;

      var token = this.token;
      var checkCode = this.imageCode.trim();
      if (!checkCode) {
        return this.errorMsg = '验证码不能为空';
      }
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].checkImageCode({
        token: token,
        checkCode: checkCode
      }).then(function (res) {
        var _res$data = res.data,
            ret = _res$data.ret,
            msg = _res$data.msg;

        if (ret == 0) {
          _this.$store.commit('hideImageCode');
          _this.errorMsg = '';
        } else {
          _this.imageCode = '';
          _this.errorMsg = msg;
          _this.setImageCodeInfo();
        }
      });
    },
    setImageCodeInfo: function setImageCodeInfo() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getImageCodeInfo({ info: this.captchaInfo }).then(function (res) {
        var _res$data2 = res.data,
            background = _res$data2.background,
            token = _res$data2.token;

        _this2.$store.commit('setImageCodeURL', pathPrefix + background);
        _this2.$store.commit('setImageCodeToken', token);
      });
    },
    close: function close() {
      this.$store.commit('hideImageCode');
    }
  }
});

/***/ }),

/***/ "b+Yh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cilB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e0Ax":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function doExpired() {}
function doLogined() {
  this.destroy();
  window.location.href = this.toUrl;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    scanWay: Boolean
  },
  data: function data() {
    return {
      status: 1, //waiting=1,expired=2,logined=3
      qrImg: '',
      qrId: '',
      timer: ''
    };
  },

  computed: {
    toUrl: function toUrl() {
      return this.$store.state.toUrl;
    }
  },
  methods: {
    getQrImg: function getQrImg() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getQrCode().then(function (res) {
        if (res.data.ret == 0) {
          _this.qrImg = res.data.img;
          _this.qrId = res.data.qrId;
          _this.timer = window.setInterval(function () {
            _this.checkStatus(_this.qrId);
          }, 1500);
        }
      });
    },
    checkStatus: function checkStatus(qrId) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].checkQr(qrId).then(function (res) {
        if (res.data.ret == 0 && _this2.status !== res.data.status) {
          _this2.status = res.data.status;
          _this2.changeStatus(_this2.status);
        }
      });
    },
    refresh: function refresh() {
      this.destroy();
      this.status = 1;
      this.initComp();
    },
    destroy: function destroy() {
      this.timer && clearInterval(this.timer);
    },
    changeStatus: function changeStatus(status) {
      switch (status) {
        case 2:
          doExpired.call(this);
          break;
        case 3:
          doLogined.call(this);
          break;
        default:
          break;
      }
    },
    initComp: function initComp() {
      this.getQrImg();
    }
  },
  created: function created() {
    this.initComp();
  },
  destroyed: function destroyed() {
    this.destroy();
  }
});

/***/ }),

/***/ "gddj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__coutries__ = __webpack_require__("GEmN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_validator__ = __webpack_require__("kWq3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_utils__ = __webpack_require__("JaHG");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var gMsg = {
  phoneError: '手机号格式不正确!',
  phoneEmpty: '请输入手机号!',
  sysError: '系统繁忙！',
  checkCodeEmpty: '请输入验证码',
  checkCodeError: '请输入正确的验证码'
};




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    visible: Boolean
  },
  data: function data() {
    return {
      showCodeList: false,
      codeList: __WEBPACK_IMPORTED_MODULE_1__coutries__["a" /* default */],
      code: '+86',
      hasQrCode: false,
      countDown: '',
      verify: {
        account: false,
        checkCode: false
      },
      jerror: {
        account: '',
        checkCode: ''
      },
      user: {
        account: '',
        checkCode: ''
      }
    };
  },

  methods: {
    confirm: function confirm() {
      var _this = this;

      // this.$store.dispatch('')
      this.checkQrCode();
      if (this.verify.checkCode) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].smsVerifyBind({
          phone_num: this.code === '+86' ? this.user.account : this.code.replace('+', '') + '-' + this.user.account,
          smsCode: this.user.checkCode,
          checkKey: this.checkKey
        }).then(function (res) {
          if (res.data.ret === 0 || res.data.success) {
            _this.$store.commit('changeBindStatus', 'BIND_SUCCESS');
            _this.dataIntialize();
          } else {
            _this.verify.checkCode = false;
            _this.jerror.checkCode = res.data.msg;
          }
        }).catch(function (e) {
          return console.log(e, e.msg);
        });
      }
    },
    confirmSuc: function confirmSuc() {
      window.location.href = this.toUrl;
      // this.$store.commit('changeBindStatus', 'NO_BIND')
    },
    toRebind: function toRebind() {
      this.dataIntialize();
      this.$store.commit('changeBindStatus', 'TO_BIND');
    },
    toggleCodeList: function toggleCodeList() {
      this.showCodeList = !this.showCodeList;
    },
    selectCode: function selectCode(obj) {
      this.code = obj.code;
      this.checkAccount();
    },
    checkAccount: function checkAccount() {
      this.verify.account = false;
      var value = this.user.account.trim();
      if (!value) {
        this.jerror.account = gMsg.phoneEmpty;
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
          return resolve(false);
        });
      }
      if (this.code === '+86' && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_validator__["a" /* default */])(value, 'mobile')) {
        this.jerror.account = gMsg.phoneError;
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
          return resolve(false);
        });
      }
      this.verify.account = true;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        return resolve(true);
      });
    },
    checkQrCode: function checkQrCode() {
      var value = this.user.checkCode.trim();
      if (!value) {
        this.verify.checkCode = false;
        this.jerror.checkCode = gMsg.checkCodeEmpty;
        return false;
      }
      if (value.length < 6 || value.length > 6) {
        this.verify.checkCode = false;
        this.jerror.checkCode = gMsg.checkCodeError;
        return false;
      }
      this.verify.checkCode = true;
      return true;
    },
    getQrCode: function getQrCode() {
      var _this2 = this;

      if (this.verify.account) {
        __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].smsSend({
          sendType: 1,
          msgType: 3,
          phone_num: this.code === '+86' ? this.user.account : this.code.replace('+', '') + '-' + this.user.account
        }).then(function (res) {
          if (res.data.success) {
            _this2.hasQrCode = true;
            _this2.countDown = 180;
            _this2.Timer && clearInterval(_this2.Timer);
            _this2.Timer = setInterval(function () {
              if (_this2.countDown === 0) {
                clearInterval(_this2.Timer);
                _this2.hasQrCode = false;
              }
              _this2.countDown--;
            }, 1000);
          } else if (res.data.ret < 0) {
            _this2.verify.account = false;
            _this2.jerror.account = res.data.msg;
          }
        }).catch(function (e) {
          console.log(e.message);
        });
      }
    },
    dataIntialize: function dataIntialize() {
      this.Timer && clearInterval(this.Timer);
      this.hasQrCode = false;
      this.countDown = 0;
      this.user.account = '';
      this.user.checkCode = '';
    }
  },
  computed: {
    bindStatus: function bindStatus() {
      return this.$store.state.bindPhoneStatus;
    },
    checkKey: function checkKey() {
      return this.$store.state.checkKey;
    },
    toUrl: function toUrl() {
      return this.$store.state.toUrl;
    }
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {
    this.dataIntialize();
  }
});

/***/ }),

/***/ "gyMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resource__ = __webpack_require__("xJrl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsencrypt__ = __webpack_require__("4C6m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsencrypt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsencrypt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_md5__ = __webpack_require__("L6bb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_md5__);




var securityKey = 'e1996c7d6e0ff0664b28af93a2eeff8f8cae84b2402d158f7bb115b735a1663d';
function encryption(password, token) {
  var content = __WEBPACK_IMPORTED_MODULE_3_md5___default()(password) + (token || '');
  var publickey = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCVhaR3Or7suUlwHUl2Ly36uVmboZ3+HhovogDjLgRE9CbaUokS2eqGaVFfbxAUxFThNDuXq/fBD+SdUgppmcZrIw4HMMP4AtE2qJJQH/KxPWmbXH7Lv+9CisNtPYOlvWJ/GHRqf9x3TBKjjeJ2CjuVxlPBDX63+Ecil2JR9klVawIDAQAB";
  var encrypt = new __WEBPACK_IMPORTED_MODULE_2_jsencrypt__["JSEncrypt"]();
  encrypt.setPublicKey(publickey);
  encrypt.getPublicKey();
  var encrypted = encrypt.encrypt(content);
  return encrypted;
}
var mobileSMSCodeURL = '/passport/v1/sms/send';
var mobileSMSCodeVerifyURL = '/passport/v1/phone/validate';
var Api = {
  checkAccount: function checkAccount(params) {
    return Api.getLoginToken().then(function (res) {
      var token = res.data.token;

      return token;
    }).then(function (token) {
      var beforMd5 = '';
      for (var key in params) {
        if (params.hasOwnProperty(key)) {
          beforMd5 += key + '=' + params[key] + '&';
        }
      }
      beforMd5 += 'nonce=' + token + '&' + securityKey;
      var signature = __WEBPACK_IMPORTED_MODULE_3_md5___default()(beforMd5.toLowerCase());
      var paramsData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, { nonce: token, signature: signature });
      return __WEBPACK_IMPORTED_MODULE_1__resource__["a" /* axios_form */].post('/passport/login/checkAccount', paramsData);
    });
  },
  getLoginToken: function getLoginToken() {
    return __WEBPACK_IMPORTED_MODULE_1__resource__["b" /* Axios */].get('/passport/token/login');
  },
  getQrCode: function getQrCode() {
    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'L';

    return __WEBPACK_IMPORTED_MODULE_1__resource__["b" /* Axios */].get('/passport/qrcode/gen?level=' + size);
  },

  checkQr: function checkQr(param) {
    return __WEBPACK_IMPORTED_MODULE_1__resource__["b" /* Axios */].get('/passport/qrcode/check/' + param);
  },
  submit: function submit(params, callback) {
    var p = this.getLoginToken().then(function (res) {
      if (res.data.ret === 0) {
        return res.data.token;
      } else {
        throw new Error('系统出错了！');
      }
    }).catch(function (e) {
      throw new Error('系统出错了！');
    });
    return p.then(function (token) {
      params.password = encryption(params.password, token);
      return __WEBPACK_IMPORTED_MODULE_1__resource__["a" /* axios_form */].post('/passport/v4/security/popupLogin', params);
    });
  },
  smsSend: function smsSend(params) {
    var p = this.getLoginToken().then(function (res) {
      if (res.data.ret === 0) {
        return res.data.token;
      } else {
        throw new Error('系统出错了！');
      }
    }).catch(function (e) {
      throw new Error('系统出错了！');
    });
    return p.then(function (token) {
      params.nonce = token;
      return __WEBPACK_IMPORTED_MODULE_1__resource__["a" /* axios_form */].post('/passport/v1/sms/send', params);
    });
  },
  smsVerifyBind: function smsVerifyBind(params) {
    var p = this.getLoginToken().then(function (res) {
      if (res.data.ret === 0) {
        return res.data.token;
      } else {
        throw new Error('系统出错了！');
      }
    }).catch(function (e) {
      throw new Error('系统出错了！');
    });
    return p.then(function (token) {
      params.nonce = token;
      return __WEBPACK_IMPORTED_MODULE_1__resource__["a" /* axios_form */].post('/passport/v1/sms/verifyBind', params);
    });
  },
  getMobileSMSCode: function getMobileSMSCode() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        phone_num = _ref.phone,
        _ref$sendType = _ref.sendType,
        sendType = _ref$sendType === undefined ? 1 : _ref$sendType,
        _ref$msgType = _ref.msgType,
        msgType = _ref$msgType === undefined ? 32 : _ref$msgType;

    var p = this.getLoginToken().then(function (res) {
      if (res.data.ret === 0) {
        return res.data.token;
      } else {
        throw new Error('系统出错了！');
      }
    }).catch(function (e) {
      throw new Error('系统出错了！');
    });
    return p.then(function (nonce) {
      return __WEBPACK_IMPORTED_MODULE_1__resource__["a" /* axios_form */].post(mobileSMSCodeURL, { phone_num: phone_num, sendType: sendType, msgType: msgType, nonce: nonce });
    });
  },
  checkMobileSMSCode: function checkMobileSMSCode() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        phone_num = _ref2.phone_num,
        smsCode = _ref2.smsCode,
        checkKey = _ref2.checkKey;

    var p = this.getLoginToken().then(function (res) {
      if (res.data.ret === 0) {
        return res.data.token;
      } else {
        throw new Error('系统出错了！');
      }
    }).catch(function (e) {
      throw new Error('系统出错了！');
    });
    return p.then(function (nonce) {
      return __WEBPACK_IMPORTED_MODULE_1__resource__["a" /* axios_form */].post(mobileSMSCodeVerifyURL, { phone_num: phone_num, smsCode: smsCode, checkKey: checkKey, nonce: nonce });
    });
  },
  getImageCodeInfo: function getImageCodeInfo() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        info = _ref3.info;

    return __WEBPACK_IMPORTED_MODULE_1__resource__["b" /* Axios */].get('/xmcaptcha-service/getCaptcha/ts-123', { params: { info: info } });
  },
  checkImageCode: function checkImageCode(_ref4) {
    var token = _ref4.token,
        checkCode = _ref4.checkCode;

    return __WEBPACK_IMPORTED_MODULE_1__resource__["b" /* Axios */].get('/xmcaptcha-service/checkCaptcha/ts-123', { params: { token: token, checkCode: checkCode } });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),

/***/ "ieps":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kWq3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validator;
var regexEnum = {
    intege: /^-?[1-9]\d*$/, //整数
    intege1: /^[1-9]\d*$/, //正整数
    intege2: /^-[1-9]\d*$/, //负整数
    num: /^([+-]?)\d*\.?\d+$/, //数字
    num1: /^[1-9]\d*|0$/, //正数（正整数 + 0）
    num2: /^-[1-9]\d*|0$/, //负数（负整数 + 0）
    decmal: /^([+-]?)\d*\.\d+$/, //浮点数
    decmal1: /^[1-9]\d*.\d*|0.\d*[1-9]\d*$/, //正浮点数
    decmal2: /^-([1-9]\d*.\d*|0.\d*[1-9]\d*)$/, //负浮点数
    decmal3: /^-?([1-9]\d*.\d*|0.\d*[1-9]\d*|0?.0+|0)$/, //浮点数
    decmal4: /^[1-9]\d*.\d*|0.\d*[1-9]\d*|0?.0+|0$/, //非负浮点数（正浮点数 + 0）
    decmal5: /^(-([1-9]\d*.\d*|0.\d*[1-9]\d*))|0?.0+|0$/, //非正浮点数（负浮点数 + 0）
    email: /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/, //邮件
    color: /^[a-fA-F0-9]{6}$/, //颜色
    url: /^http[s]?:\/\/([\w-]+\.)+[\w-]+([\w\-.\/\?\%\&\=\#]*)?$/, //url
    chinese: /^[\u4E00-\u9FA5\uF900-\uFA2D]+$/, //仅中文
    include_chinese: /[\u4E00-\u9FA5\uF900-\uFA2D]/g,

    ascii: /^[\x00-\xFF]+$/, //仅ACSII字符
    zipcode: /^\d{6}$/, //邮编
    //mobile: /^1[0-9]{10}$/, //手机
    mobile: /^1(([3578][0-9])|(4[57]))[0-9]{8}$/, //手机
    ip4: /^(25[0-5]|2[0-4]\d|[0-1]\d{2}|[1-9]?\d)\.(25[0-5]|2[0-4]\d|[0-1]\d{2}|[1-9]?\d)\.(25[0-5]|2[0-4]\d|[0-1]\d{2}|[1-9]?\d)\.(25[0-5]|2[0-4]\d|[0-1]\d{2}|[1-9]?\d)$/, //ip地址
    notempty: /^\S+$/, //非空
    picture: /(.*)\.(jpg|bmp|gif|ico|pcx|jpeg|tif|png|raw|tga)$/, //图片
    rar: /(.*)\.(rar|zip|7zip|tgz)$/, //压缩文件
    date: /^\d{4}(\-|\/|\.)\d{1,2}\1\d{1,2}$/, //日期
    qq: /^[1-9]*[1-9][0-9]*$/, //QQ号码
    tel: /^(([0\+]\d{2,3}-)?(0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/, //电话号码的函数(包括验证国内区号,国际区号,分机号)
    username: /^\w+$/, //用来用户注册。匹配由数字、26个英文字母或者下划线组成的字符串
    letter: /^[A-Za-z]+$/, //字母
    letter_u: /^[A-Z]+$/, //大写字母
    letter_l: /^[a-z]+$/, //小写字母
    idcard: /^[1-9]([0-9]{13}|[0-9]{16})([0-9]|X)$/ //身份证

};

function validator(value, type) {
    if (type === 'mobile') {
        return true;
    }
    var returnValue = false;
    if (regexEnum[type]) {
        if (regexEnum[type].test(value)) {
            returnValue = true;
        }
    }
    return returnValue;
}

/***/ }),

/***/ "l+I4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");


__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */]);
var state = {
  bindPhoneStatus: 'NO_BIND', //NO_BIND, TO_BIND, BIND_SUCCESS, BIND_FAILED
  checkKey: '',
  toUrl: '/explore',
  SMSCodeVisible: false,
  mobileReal: '13999999999',
  mobileShow: '139****9999',
  imageCodeURL: 'about:blank',
  imageCodeToken: '',
  captchaInfo: '',
  imageCodeVisible: false
};
var mutations = {
  showImageCode: function showImageCode(state) {
    state.imageCodeVisible = true;
  },
  hideImageCode: function hideImageCode(state) {
    state.imageCodeVisible = false;
  },
  setCaptchaInfo: function setCaptchaInfo(state, value) {
    state.captchaInfo = value;
  },
  setMobileReal: function setMobileReal(state, value) {
    state.mobileReal = value;
  },
  setMobileShow: function setMobileShow(state, value) {
    state.mobileShow = value;
  },
  changeBindStatus: function changeBindStatus(state, status) {
    state.bindPhoneStatus = status;
  },
  setCheckKey: function setCheckKey(state, key) {
    state.checkKey = key;
  },
  setToUrl: function setToUrl(state, url) {
    state.toUrl = url;
  },
  showSMSCode: function showSMSCode(state) {
    state.SMSCodeVisible = true;
  },
  hideSMSCode: function hideSMSCode(state) {
    state.SMSCodeVisible = false;
  },
  setImageCodeURL: function setImageCodeURL(state, value) {
    state.imageCodeURL = value;
  },
  setImageCodeToken: function setImageCodeToken(state, value) {
    state.imageCodeToken = value;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* default */].Store({
  state: state,
  mutations: mutations
}));

/***/ }),

/***/ "ocZP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addBind;

function name2Type(name) {
  var type = {
    tSina: 1,
    qzone: 2,
    tQQ: 2,
    renren: 3,
    weixin: 12
  };
  return type[name];
}
function addBind(name, success) {
  var callbackName = 'toLoginCallback';
  var type = name2Type(name);
  document.domain = 'ximalaya.com';
  window[callbackName] = function (data) {
    success(data);
    window[callbackName] = null;
  };
  window.open('/passport/auth/' + type + '/authorize?customerFunction=' + callbackName, '', 'height=560, width=760, left=400');
}

/***/ }),

/***/ "rsJ2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vxYB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:"sms-pop",staticClass:"pop",attrs:{"id":"sms-pop"}},[_c('transition',{attrs:{"name":"sms","mode":"out-in"}},[(_vm.codeVisible)?_c('div',{staticClass:"sms-pop__form"},[_c('h4',{staticClass:"sms-pop__form-title"},[_vm._v("短信验证码")]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('span',{staticClass:"sms-pop__phoneShow"},[_vm._v("手机号:   "+_vm._s(_vm.mobileShow))])]),_vm._v(" "),_c('div',{staticClass:"form-row",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"sms-pop__code"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.smsCode),expression:"smsCode"}],staticClass:"sms-input xm-input__inner",attrs:{"placeholder":"验证码"},domProps:{"value":(_vm.smsCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.smsCode=$event.target.value}}})]),_c('button',{class:("sms-btn " + (_vm.count > 0 ? ' disabled' : '')),on:{"click":_vm._getSMSCode}},[_vm._v(_vm._s(_vm.count > 0 ? (_vm.count + 's') : '获取验证码'))])]),_vm._v(" "),_c('div',{staticClass:"sms-pop__form-ctrl"},[_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errorMsg))]),_c('button',{staticClass:"sms-code-btn btn-cancel",on:{"click":_vm.close}},[_vm._v("取消")]),_c('button',{staticClass:"sms-code-btn btn-confirm",attrs:{"type":"button"},on:{"click":_vm.toSubmit}},[_vm._v("确认")])])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_qrcode_login__ = __webpack_require__("O+Gv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_j_form__ = __webpack_require__("2clu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pop_bindphone__ = __webpack_require__("zhTo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pop_smsCode__ = __webpack_require__("DYbR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pop_imageCode__ = __webpack_require__("Akk1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__third_part__ = __webpack_require__("ocZP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_utils__ = __webpack_require__("JaHG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// 页面中引入埋点依赖
(function (e, t, n, a, o, i, m) {
  e._xmObjName = o, e[o] = e[o] || function () {
    (e[o].q = e[o].q || []).push(arguments);
  }, e[o].l = e[o].l || +new Date(), i = t.createElement(n), i.async = true, i.src = a, m = t.getElementsByTagName(n)[0], m.parentNode.insertBefore(i, m);
})(window, document, "script", "//s1.xmcdn.com/lib/xmlog/last/xmlog.js", "xmLog");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    qrcodeLogin: __WEBPACK_IMPORTED_MODULE_0__components_qrcode_login__["a" /* default */],
    jForm: __WEBPACK_IMPORTED_MODULE_1__components_j_form__["a" /* default */],
    popBindphone: __WEBPACK_IMPORTED_MODULE_2__components_pop_bindphone__["a" /* default */],
    popSmsCode: __WEBPACK_IMPORTED_MODULE_3__components_pop_smsCode__["a" /* default */],
    popImageCode: __WEBPACK_IMPORTED_MODULE_4__components_pop_imageCode__["a" /* default */]
  },
  data: function data() {
    return {
      curView: 'jForm',
      bindphoneVisible: true,
      codeVisible: false
    };
  },

  computed: {
    toUrl: function toUrl() {
      return this.$store.state.toUrl;
    }
  },
  methods: {
    toggleLoginWay: function toggleLoginWay() {
      if (this.curView == 'jForm') {
        this.curView = 'qrcodeLogin';
      } else {
        this.curView = 'jForm';
      }
      //切换登录方式的点击埋点
      xmLog && xmLog('pv.send', 'event', {
        currPage: "login",
        currPageId: null,
        currPageUrl: "/passport/login",
        item: '' + (this.curView == 'jForm' ? "password" : "2dCode"),
        itemId: null,
        module: null,
        serviceId: "click"
      });
    },
    authLogin: function authLogin(name) {
      var _this = this;

      /* 点击第三方登录埋点 */
      var _item = name === 'weixin' ? name : name === 'tQQ' ? "qq" : "weibo";
      xmLog && xmLog('pv.send', 'event', {
        currPage: "login",
        currPageId: null,
        currPageUrl: "/passport/login",
        item: _item,
        itemId: null,
        module: null,
        serviceId: "click"
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__third_part__["a" /* addBind */])(name, function (_ref) {
        var toUrl = _ref.toUrl,
            uid = _ref.uid,
            gotoBindMPhone = _ref.gotoBindMPhone,
            checkKey = _ref.checkKey;

        if (gotoBindMPhone) {
          _this.$store.commit('changeBindStatus', 'TO_BIND');
          _this.$store.commit('setCheckKey', checkKey);
          toUrl && _this.$store.commit('setToUrl', toUrl);
        } else {
          window.location.href = _this.toUrl;
        }
      });
    },
    authRegister: function authRegister() {
      //点击注册时埋点
      xmLog && xmLog('pv.send', 'event', {
        currPage: "login",
        currPageId: null,
        currPageUrl: "/passport/login",
        item: "register",
        itemId: null,
        module: "bottomTool",
        serviceId: "click"
      });
    },
    pageViewLog: function pageViewLog() {
      /* 页面进入时的埋点 */
      xmLog && xmLog('pv.create', {
        currPage: 'login'
      });
      xmLog && xmLog('pv.send', 'event', {
        currPage: "login",
        currPageId: null,
        currPageUrl: "/passport/login",
        durationTime: "0s",
        prevItem: null,
        prevItemId: null,
        prevModule: null,
        prevPage: null,
        prevPageId: null,
        prevPageUrl: null,
        serviceId: "pageView"
      });
    }
  },
  created: function created() {
    var toUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__common_utils__["a" /* queryHref */])('fromUri');

    if (!!toUrl) {
      this.$store.commit('setToUrl', decodeURIComponent(toUrl));
    }
  },
  mounted: function mounted() {
    this.codeVisible = true;
    this.pageViewLog();
  }
});

/***/ }),

/***/ "xJrl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return axios_form; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0_axios___default.a; });


var axios_form = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  transformRequest: [function (data) {
    data = __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(data);
    return data;
  }],
  headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
});



/***/ }),

/***/ "xKRb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__("gyMJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      errorMsg: '',
      count: 0,
      smsCode: ''
    };
  },

  computed: {
    codeVisible: function codeVisible() {
      return this.$store.state.SMSCodeVisible;
    },
    mobileShow: function mobileShow() {
      return this.$store.state.mobileShow;
    },
    mobileReal: function mobileReal() {
      return this.$store.state.mobileReal;
    },
    toUrl: function toUrl() {
      return this.$store.state.toUrl;
    }
  },
  watch: {
    codeVisible: function codeVisible(val) {
      if (!val) {
        this.resetForm();
      }
    }
  },
  methods: {
    resetForm: function resetForm() {
      this.errorMsg = '';
      this.smsCode = '';
      clearTimeout(this.timer);
      this.count = 0;
    },
    _getSMSCode: function _getSMSCode() {
      var _this = this;

      var phone = this.mobileReal;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getMobileSMSCode({ phone: phone }).then(function (res) {
        if (res.data.success) {
          _this.startCountDown();
        } else {
          _this.errorMsg = res.data.msg;
        }
      });
    },
    countDown: function countDown() {
      var _this2 = this;

      var count = this.count;

      if (count <= 0) {
        return this.timer = null;
      }
      this.count--;
      this.timer = setTimeout(function () {
        _this2.countDown();
      }, 1000);
    },
    startCountDown: function startCountDown() {
      var total = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 60;

      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.count = total;
      this.countDown();
    },
    close: function close() {
      this.$store.commit('hideSMSCode');
    },
    toSubmit: function toSubmit() {
      var _this3 = this;

      var phone_num = this.mobileReal;
      var smsCode = this.smsCode.trim();
      var checkKey = this.$store.state.checkKey;
      var fromUri = this.toUrl;
      if (!smsCode) {
        return this.errorMsg = '验证码不能为空';
      }
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].checkMobileSMSCode({
        phone_num: phone_num,
        smsCode: smsCode,
        checkKey: checkKey
      }).then(function (res) {
        var _res$data = res.data,
            success = _res$data.success,
            msg = _res$data.msg;

        if (success) {
          _this3.$store.commit('hideSMSCode');
          fromUri ? window.location.href = fromUri : window.location.reload();
          return true;
        }
        _this3.errorMsg = msg;
      });
    }
  }
});

/***/ }),

/***/ "zVL+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zhTo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pop_bindphone_vue__ = __webpack_require__("gddj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c39755c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pop_bindphone_vue__ = __webpack_require__("OamE");
function injectStyle (ssrContext) {
  __webpack_require__("zVL+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pop_bindphone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c39755c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pop_bindphone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.js